import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/compact.css'; // Import compact styles for zoomed-out view
import App from './App';
import resourcePreloader from './utils/resourcePreloader';
import './utils/testPersistence';

// Make resource preloader globally available
window.resourcePreloader = resourcePreloader;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enhanced service worker registration with better error handling
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content is available, show update notification
                console.log('New version available! Consider refreshing.');
                // Could show a toast notification here
              }
            });
          }
        });
        
                // Initialize resource preloader after SW is ready
        setTimeout(() => {
          // Preload critical resources based on current route
          const currentRoute = window.location.pathname;
          if (currentRoute.includes('roster')) {
            resourcePreloader.preloadForRoute('roster');
          } else if (currentRoute.includes('planning')) {
            resourcePreloader.preloadForRoute('planning');
          } else if (currentRoute.includes('forecast')) {
            resourcePreloader.preloadForRoute('forecast');
          }
          
          // Preload common resources
          resourcePreloader.preload([
            '/api/applications',
            '/api/tags',
            '/api/rates'
          ], resourcePreloader.priorities.LOW);
        }, 1000);
      })
      .catch((registrationError) => {
        console.log('SW registration failed (this is normal in development): ', registrationError);
      });
  });
} else if (process.env.NODE_ENV === 'development') {
  console.log('Service Worker disabled in development mode');
} else {
  console.warn('Service Worker not supported in this browser');
}

// End of file